import { DataFieldValue } from "src/app/shared/datafields/models";
import { ScheduleItem } from "src/app/shared/scheduling/models";

export class SchedulerTask {
    Id: number;
    Name: string;
    Description: string;
    SchedulerTaskHandlerId: number;
    ArtifactsConfig: string;
    FrequencyInSeconds: number | null;
    ScheduleItemsId: number | null;
    ExecutionTimeoutInMinutes: number | null;
    IsSystem: boolean;
    CreatedBy: number;
    CreatedDate: Date;
    UpdatedBy: number | null;
    UpdatedDate: Date | null;

    constructor(source?: Partial<SchedulerTask>) {
        // Default values
        this.Id = 0; // Assuming 0 is a suitable default for ID
        this.Name = '';
        this.Description = '';
        this.SchedulerTaskHandlerId = null;
        this.ArtifactsConfig = '';
        this.FrequencyInSeconds = null;
        this.ScheduleItemsId = null;
        this.ExecutionTimeoutInMinutes = null;
        this.IsSystem = false;
        this.CreatedBy = 0;
        this.CreatedDate = new Date();
        this.UpdatedBy = null;
        this.UpdatedDate = null;

        // Override with source values if provided
        if (source) {
            Object.assign(this, source);
        }
    }
}

export class SchedulerTaskHandler {
    Id: number;
    Name: string;
    Description: string;
    ArtifactId: string;
    IsSystem: boolean;
    CreatedBy: number;
    CreatedDate: Date;
    UpdatedBy: number | null;
    UpdatedDate: Date | null;
    IsUserAvailable: boolean;

    constructor(source?: Partial<SchedulerTask>) {
        // Default values
        this.Id = 0; // Assuming 0 is a suitable default for ID
        this.Name = '';
        this.Description = '';
        this.ArtifactId = '';
        this.IsSystem = false;
        this.CreatedBy = 0;
        this.CreatedDate = new Date();
        this.UpdatedBy = null;
        this.UpdatedDate = null;
        this.IsUserAvailable = true;

        // Override with source values if provided
        if (source) {
            Object.assign(this, source);
        }
    }
}

export class TriggerEntity {
    constructor(source?: Partial<TriggerEntity>) {
        if (source) {
            Object.assign(this, source);
        }
    }

    Id = 0;
    Weekdays = ''; // Comma-separated values like: 'Monday,Thursday,Saturday'
    StartTime = '';
    EndTime = '';
}

export class ScheduledItemEntity {
    constructor(source?: Partial<ScheduledItemEntity>) {
        if (source) {
            Object.assign(this, source);
            if (source.StartDate) {
                this.StartDate = new Date(source.StartDate);
            }
            if (source.EndDate) {
                this.EndDate = new Date(source.EndDate);
            }
            if (source.Enabled) {
                this.Enabled = Boolean(source.Enabled);
            }
        }
    }

    Id = 0;
    StartDate: Date = null;
    EndDate: Date = null;
    Enabled = false;
}

export class SchedulerTaskPresentation {
    constructor(source?: Partial<SchedulerTaskPresentation>) {
        if (source) {
            Object.assign(this, source);
            if (source.SchedulerTask) {
                this.SchedulerTask = new SchedulerTask(source.SchedulerTask);
            }
            if (source.ScheduledItem) {
                this.ScheduledItem = new ScheduleItem();
                this.ScheduledItem.Enabled = source.ScheduledItem?.Enabled;
                this.ScheduledItem.EndDate = source.ScheduledItem?.EndDate;
                this.ScheduledItem.StartDate = source.ScheduledItem?.StartDate;
                this.ScheduledItem.Id = source.ScheduledItem?.Id;
                this.ScheduledItem.Triggers = source.ScheduledItem?.Triggers;
                this.ScheduledItem.AbsenceItems = source.ScheduledItem?.AbsenceItems;
            }
            if (source.SchedulerTaskHandler) {
                this.SchedulerTaskHandler = new SchedulerTaskHandler();
                this.SchedulerTaskHandler.ArtifactId = source.SchedulerTaskHandler.ArtifactId;
                this.SchedulerTaskHandler.CreatedBy = source.SchedulerTaskHandler.CreatedBy;
                this.SchedulerTaskHandler.CreatedDate = source.SchedulerTaskHandler.CreatedDate;
                this.SchedulerTaskHandler.Description = source.SchedulerTaskHandler.Description;
                this.SchedulerTaskHandler.Id = source.SchedulerTaskHandler.Id;
                this.SchedulerTaskHandler.IsSystem = source.SchedulerTaskHandler.IsSystem;
                this.SchedulerTaskHandler.IsUserAvailable = source.SchedulerTaskHandler.IsUserAvailable;
                this.SchedulerTaskHandler.Name = source.SchedulerTaskHandler.Name;
                this.SchedulerTaskHandler.UpdatedBy = source.SchedulerTaskHandler.UpdatedBy;
                this.SchedulerTaskHandler.UpdatedDate = source.SchedulerTaskHandler.UpdatedDate;
            }
        }
    }

    SchedulerTask: SchedulerTask = new SchedulerTask();
    SchedulerTaskHandler: SchedulerTaskHandler = new SchedulerTaskHandler();
    ScheduledItem?: ScheduleItem = null;
}


export interface SchedulerTaskContainer {
    Configuration: SchedulerTaskPresentation;
    ConfigValues: DataFieldValue[];
}
